import { icons } from '@assets/icons';
import { memo } from 'react';

const BusinessDetailActions = memo(
  ({ onSearchAnother, onClaim, claimDisabled = false, claimLabel = 'Claim this Business' }) => (
    <div className="flex w-full gap-business-actions">
      <button
        type="button"
        onClick={onSearchAnother}
        disabled={claimDisabled}
        className="flex desktop:min-h-11 min-h-8 flex-1 cursor-pointer items-center justify-center gap-0.75 desktop:gap-1 rounded-full bg-merchant-text-primary px-(--space-section) py-2.5 desktop:py-3 desktop:text-[16px] text-sm font-semibold leading-3.75 desktop:leading-5 text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <img
          src={icons.search}
          alt=""
          className="icon-md shrink-0 brightness-0 invert"
          aria-hidden="true"
        />
        <span>Search another business</span>
      </button>

      <button
        type="button"
        onClick={onClaim}
        disabled={claimDisabled}
        className="desktop:min-h-11 min-h-8 flex-1 cursor-pointer rounded-full bg-merchant-action px-(--space-section) py-2.5 desktop:py-3 desktop:text-[16px] text-sm font-semibold leading-3.75 desktop:leading-5 text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {claimLabel}
      </button>
    </div>
  ),
);

BusinessDetailActions.displayName = 'BusinessDetailActions';

export default BusinessDetailActions;
